import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import Journey from './components/Journey';
import Consulting from './components/Consulting';
import Community from './components/Community';
import Contact from './components/Contact';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Journey />
        <Consulting />
        <Community />
        <Contact />
      </main>
    </div>
  );
}

export default App;
